import {
	Action,
	AnyAction,
	configureStore,
	ThunkAction,
} from '@reduxjs/toolkit';

import { createLogger } from 'redux-logger';
import documentReducer from './slices/documentSlice';
import paymentReducer from './slices/paymentSlice';
import preferenceReducer from './slices/preferenceSlice';
import profileReducer from './slices/profileSlice';
import sessionReducer from './slices/sessionSlice';
import SignatureReducer from './slices/signatureSlice';
import StageReducer from './slices/stageSlice';
import testReducer from './slices/testSlice';
import tncReducer from './slices/termsAndConditions';

const logger = createLogger();

export function makeStore() {
	return configureStore({
		reducer: {
			test: testReducer,
			preference: preferenceReducer,
			profile: profileReducer,
			document: documentReducer,
			tnc: tncReducer,
			signature: SignatureReducer,
			stage: StageReducer,
			session: sessionReducer,
			payment: paymentReducer,
		},
		middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
	});
}

export const store = makeStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
